import { Injectable, signal } from '@angular/core';
import { ICompanyOwner } from '@modules/configs/pages/companies/services/companies.service';

export interface IContMigration {
  dc: number;
  fd: number;
  fmd: number;
}

@Injectable({
  providedIn: 'root',
})
export class GlobalStateService {
  private readonly _state = signal({
    showLoading: false,
    contMigration: {
      dc: 0,
      fd: 0,
      fmd: 0,
    },
    checkStatusWhatsappBot: false,
    companies: Array<ICompanyOwner>(),
    updateDahboardSupportTicket: false,
    selectedCompanyId: 1,
  });

  readonly state$ = this._state.asReadonly();

  setContMigration(contMigration: IContMigration) {
    this._state.update((state) => {
      return {
        ...state,
        contMigration,
      };
    });
  }

  setShowLoading(value: boolean): void {
    this._state.update((state) => {
      return {
        ...state,
        showLoading: value,
      };
    });
  }

  setCheckStatusWhatsappBot(value: boolean): void {
    this._state.update((state) => {
      return {
        ...state,
        checkStatusWhatsappBot: value,
      };
    });
  }

  setCompanies(companies: Array<ICompanyOwner>): void {
    this._state.update((state) => {
      return {
        ...state,
        companies,
      };
    });
  }

  getCompany(id: number): ICompanyOwner | undefined {
    return this._state().companies.find((c) => c.id === id);
  }

  setUpdateDahboardSupportTicket(value: boolean): void {
    this._state.update((state) => {
      return {
        ...state,
        updateDahboardSupportTicket: value,
      };
    });
  }
  setSelectedCompanyId(companyId: number): void {
    this._state.update((state) => {
      return {
        ...state,
        selectedCompanyId: companyId,
      };
    });
  }
}
